/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';
import PropTypes from 'prop-types';
import {
    Heading,
    Stack,
    Spinner,
    Text,
    StyledModal,
    HtmlParser,
    ModalActions,
    Button,
} from 'sarsaparilla';

export default function SpinnerModal({
    children,
    heading = 'Please wait ...',
    message,
    isOpen = false,
    isSpinning = true,
    retryNumber,
    maxRetries,
    handleBookingErrorModalClose,
    ...rest
}) {
    return (
        <StyledModal
            aria-label="Please wait"
            size="sm"
            shouldShowCloseButton={false}
            isOpen={isOpen}
            {...rest}
        >
            {isSpinning && (
                <Stack>
                    <Heading headingLevel={1} appearance="h4">
                        {heading}
                    </Heading>
                    <Text aria-live="polite">
                        <HtmlParser html={message} />
                    </Text>
                    {retryNumber > 0 && (
                        <Text style={{ textAlign: 'center' }} aria-live="polite">
                            {`Retry ${retryNumber} of ${maxRetries}`}
                        </Text>
                    )}
                    <Spinner size="md" />
                    {retryNumber > 0 && (
                        <ModalActions>
                            <Button
                                appearance="tertiary"
                                onClick={handleBookingErrorModalClose(true)}
                                gaTrackingId="740727778874"
                            >
                                Cancel and Choose a Different Date
                            </Button>
                        </ModalActions>
                    )}
                </Stack>
            )}
            {!isSpinning && <div aria-live="polite">{children}</div>}
        </StyledModal>
    );
}

SpinnerModal.propTypes = {
    /** If the modal is open or not */
    isOpen: PropTypes.bool,

    /** If the spinner and rotating messages are visible */
    isSpinning: PropTypes.bool,

    /** Heading displayed while spinning */
    heading: PropTypes.node,

    /** Array of messages to display while spinning. */
    message: PropTypes.node,

    /** Function to handle button click*/
    handleBookingErrormodalClose: PropTypes.func,

    /** The content shown if isSpinning is false */
    children: PropTypes.node,
};
